import Vue from 'vue'
import axios from 'axios'

const initState = {}

export default {
  namespaced: true,
  state: Vue.util.extend({}, initState),
  mutations: {},
  actions: {
    getAdminTemplates({ commit }, queries) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/admin-templates`, { params: queries })
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    getAdminPageTemplates({ commit }, queries) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/admin-page-templates`, { params: queries })
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    getAdminTemplateCategories({ commit }, queries) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/admin-template-categories`, { params: queries })
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    getAllTemplateCategories({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/template-categories`)
          .then((res) => resolve(res.data.categories))
          .catch((error) => reject(error))
      })
    },
    getAllPageTemplateCategories({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/page-template-categories`)
          .then((res) => resolve(res.data.categories))
          .catch((error) => reject(error))
      })
    },
    getAdminPageTemplateCategories({ commit }, queries) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/admin-page-template-categories`, { params: queries })
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    getTemplates({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/templates`)
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    getAllTemplatePages({ commit }, { templateId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/admin-templates/${templateId}/pages/all`)
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    getPageTemplates({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/page-templates`)
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    getTemplateForms({ commit }, templateId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/admin-templates/${templateId}/forms`)
          .then((res) => resolve(res.data.forms))
          .catch((error) => reject(error))
      })
    },
    getTemplateMenus({ commit }, templateId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/admin-templates/${templateId}/menus`)
          .then((res) => resolve(res.data.menus))
          .catch((error) => reject(error))
      })
    },
    getTemplateBlogs({ commit }, { templateId, queries }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/public/admin-templates/${templateId}/blogs`, { params: queries })
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    getTemplateBlog({ commit }, { templateId, blogId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/admin-templates/${templateId}/blogs/${blogId}`)
          .then((res) => resolve(res.data.blog))
          .catch((error) => reject(error))
      })
    },
    getTemplatePagesList({ commit }, { templateId, queries }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/admin-templates/${templateId}/pages/list`, { params: queries })
          .then((res) => resolve(res.data.pages))
          .catch((error) => reject(error))
      })
    },
    getTemplatePage({ commit }, { templateId, pageId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/public/admin-templates/${templateId}/pages/${pageId}`)
          .then((res) => resolve(res.data.page))
          .catch((error) => reject(error))
      })
    },
    getTemplatePageByUniqueName({ commit }, { templateId, uniqueName }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/admin-templates/${templateId}/unique-names/${uniqueName}`)
          .then((res) => resolve(res.data.page))
          .catch((error) => reject(error))
      })
    },
    getTemplateForm({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/admin-templates/${params.templateId}/forms/${params.formId}`)
          .then((res) => resolve(res.data.form))
          .catch((error) => reject(error))
      })
    },
    getTemplateMenu({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/admin-templates/${params.templateId}/menus/${params.menuId}`)
          .then((res) => resolve(res.data.menu))
          .catch((error) => reject(error))
      })
    },
    getAdminTemplate({ commit }, { templateId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/admin-templates/${templateId}`)
          .then((res) => resolve(res.data.template))
          .catch((error) => reject(error))
      })
    },
    getAdminPageTemplate({ commit }, { pageTemplateId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/admin-page-templates/${pageTemplateId}`)
          .then((res) => resolve(res.data.pageTemplate))
          .catch((error) => reject(error))
      })
    },
    createTemplateMenu({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-templates/${params.templateId}/menus`, params)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    createTemplateForm({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-templates/${params.templateId}/forms`, params)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    createTemplateBlog({ commit }, blog) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-templates/${blog.template_id}/blogs`, blog)
          .then((res) => resolve(res.data.blog))
          .catch((error) => reject(error))
      })
    },
    createTemplatePage({ commit }, page) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-templates/${page.template_id}/pages`, page)
          .then((res) => resolve(res.data.page))
          .catch((error) => reject(error))
      })
    },
    createAdminTemplate({ commit }, template) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-templates`, template)
          .then((res) => resolve(res.data.template))
          .catch((error) => reject(error))
      })
    },
    createAdminPageTemplate({ commit }, pageTemplate) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-page-templates`, pageTemplate)
          .then((res) => resolve(res.data.pageTemplate))
          .catch((error) => reject(error))
      })
    },
    createTemplateCategory({ commit }, category) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-template-categories`, category)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    createPageTemplateCategory({ commit }, category) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-page-template-categories`, category)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    updateTemplateMenu({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/admin-templates/${params.templateId}/menus`, params)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    updateTemplateForm({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/admin-templates/${params.templateId}/forms`, params)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    updateTemplateBlog({ commit }, blog) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/admin-templates/${blog.template_id}/blogs/${blog.id}`, blog)
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    updateTemplatePage({ commit }, page) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/admin-templates/${page.template_id}/pages/${page.id}`, page)
          .then((res) => resolve(res.data.page))
          .catch((error) => reject(error))
      })
    },
    updateTemplatePageDesign({ commit }, page) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/admin-templates/${page.template_id}/pages/${page.id}/design`, page)
          .then((res) => resolve(res.data.shouldReload))
          .catch((error) => reject(error))
      })
    },
    updateAdminTemplate({ commit }, template) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/admin-templates/${template.id}`, template)
          .then((res) => resolve(res.data.template))
          .catch((error) => reject(error))
      })
    },
    updateTemplateCategory({ commit }, category) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/admin-template-categories/${category.id}`, category)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    updatePageTemplateCategory({ commit }, category) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/admin-page-template-categories/${category.id}`, category)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    updateAdminTemplateSettings({ commit }, template) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/admin-templates/${template.id}/settings`, template)
          .then((res) => resolve(res.data.template))
          .catch((error) => reject(error))
      })
    },
    updateAdminPageTemplate({ commit }, pageTemplate) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/admin-page-templates/${pageTemplate.id}`, pageTemplate)
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    updatePageRelations({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-templates/${params.templateId}/page-relations`, params)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    publishTemplateBlog({ commit }, { templateId, blogId }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-templates/${templateId}/blogs/${blogId}/publish`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    publishTemplatePage({ commit }, { templateId, pageId }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-templates/${templateId}/pages/${pageId}/publish`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    publishTemplateCategory({ commit }, categoryId) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-template-categories/${categoryId}/publish`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    publishPageTemplateCategory({ commit }, categoryId) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-page-template-categories/${categoryId}/publish`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    adminPublishTemplate({ commit }, templateId) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-templates/${templateId}/publish`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    adminPublishPageTemplate({ commit }, pageTemplateId) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-page-templates/${pageTemplateId}/publish`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    clonePageTemplateCategory({ commit }, categoryId) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-page-template-categories/${categoryId}/clone`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    cloneTemplateCategory({ commit }, categoryId) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-template-categories/${categoryId}/clone`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    cloneTemplateBlog({ commit }, { templateId, blogId }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-templates/${templateId}/blogs/${blogId}/clone`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    cloneTemplatePage({ commit }, { templateId, pageId }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-templates/${templateId}/pages/${pageId}/clone`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    cloneTemplate({ commit }, templateId) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-templates/${templateId}/clone`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    clonePageTemplate({ commit }, pageTemplateId) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-page-templates/${pageTemplateId}/clone`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    setTemplateHomePage({ commit }, { templateId, pageId }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-templates/${templateId}/pages/${pageId}/set-home`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },    
    importTemplateXML({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`admin-templates/import-xml`, data)
          .then(() => resolve(true))
          .catch((err) => reject(err))
      })
    },
    adminImportPageTemplate({ commit }, pageUniqueId) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-page-templates/import/page/${pageUniqueId}/unique-id`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    adminImportLandingTemplate({ commit }, landingUniqueId) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-templates/import/landing/${landingUniqueId}/unique-id`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    convertTemplate({ commit }, templateId) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-templates/${templateId}/convert`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    deleteTemplateMenu({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/admin-templates/${params.templateId}/menus/${params.menuId}`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    deleteTemplateForm({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/admin-templates/${params.templateId}/forms/${params.formId}`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    deleteTemplateBlog({ commit }, { templateId, blogId }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/admin-templates/${templateId}/blogs/${blogId}`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    deleteTemplatePage({ commit }, { templateId, pageId }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/admin-templates/${templateId}/pages/${pageId}`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    deleteAdminTemplate({ commit }, { templateId }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/admin-templates/${templateId}`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    deletePageTemplateCategory({ commit }, categoryId) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/admin-page-template-categories/${categoryId}`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    deleteTemplateCategory({ commit }, categoryId) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/admin-template-categories/${categoryId}`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    deleteAdminPageTemplate({ commit }, { pageTemplateId }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/admin-page-templates/${pageTemplateId}`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    }
  },
  getters: {}
}